import { render, staticRenderFns } from "./BBAlert.vue?vue&type=template&id=12ac2cdf&scoped=true"
import script from "./BBAlert.vue?vue&type=script&lang=js"
export * from "./BBAlert.vue?vue&type=script&lang=js"
import style0 from "./BBAlert.vue?vue&type=style&index=0&id=12ac2cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ac2cdf",
  null
  
)

export default component.exports